import React from "react";
import "./Meanings.css";

export default function Synonyms(props) {
    if (props.synonyms && props.synonyms.length > 0) {
        return (
            <div className="Synonyms">
                <strong>Synonyms:</strong> {props.synonyms.join("; ")}.
            </div>
        );
    } else {
        return null;
    }
}